// /user/* and token endpoints.

import { buildFakeJwt, defineRoutes, demoError } from '../core';
import type { RegisterRequest, UpdateUserRequest } from '../../types/auth.type';
import { currentDemoUser, registerUser, replaceUserSites, updateUser, usersFor } from '../data/users';
import { body, guarded } from './errors';

const NOT_IN_DEMO = 'Not available in demo';

export const authRoutes = defineRoutes([
  ['post', '/user/login', () => demoError(400, NOT_IN_DEMO)],
  ['post', '/user/forgot-password', () => demoError(400, NOT_IN_DEMO)],
  ['post', '/user/reset-password', () => demoError(400, NOT_IN_DEMO)],
  [
    'post',
    '/app_user/refresh_token',
    () => {
      const token = buildFakeJwt();
      return { result: { access_token: token, refresh_token: token } };
    },
  ],
  // Zero creates organisation users through register (the add-user form).
  ['post', '/user/register', (ctx) => guarded(() => ({ result: registerUser(body<RegisterRequest>(ctx.body), ctx.orgId) }))],
  ['get', '/user/me', () => ({ result: currentDemoUser() })],
  ['get', '/user/:orgId', (ctx) => ({ result: usersFor(ctx.params.orgId) })],
  [
    'put',
    '/user/:orgId/:userId/sites',
    (ctx) => {
      const ids = body<{ collection_site_ids?: unknown }>(ctx.body).collection_site_ids;
      const user = replaceUserSites(ctx.params.orgId, ctx.params.userId, Array.isArray(ids) ? ids.map(String) : []);
      return user ? { result: user } : demoError(404, 'User not found');
    },
  ],
  [
    'put',
    '/user/:orgId/:userId',
    (ctx) => {
      const user = updateUser(ctx.params.orgId, ctx.params.userId, body<UpdateUserRequest>(ctx.body));
      return user ? { result: user } : demoError(404, 'User not found');
    },
  ],
]);
